import React, { useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";

//Import Images
import error from "../../assets/images/error-img.png";
import withRouter from "Components/Common/withRouter";
import { verificationEmailFun } from "slices/auth/emailVerification/thunk";
import { verfify_email } from "../../helpers/AuthType/authBackend";

const EmailVerification = () => {
  //meta title
  document.title = "Verification Email";
  const [searchParams] = useSearchParams();
  const tokenParam = searchParams.get("token");
  console.log(tokenParam);

  useEffect(() => {
    const sendData = async () => {
      const response = await verfify_email(tokenParam);
      console.log(response);
    };
    sendData();
  }, []);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row>
            <Col lg="12">
              <div className="text-center mb-5">
                <h1 className="text-uppercase">FELICIDADES!!</h1>
                <p className="text-uppercase">
                  Tu cuenta Ha sido verificada con exito, ya puedes volver
                </p>
                <div className="mt-5 text-center">
                  <Link
                    className="btn btn-primary waves-effect waves-light "
                    to="/login"
                  >
                    Back to Dashboard
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md="8" xl="6">
              <div>
                <img src={error} alt="" className="img-fluid" />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(EmailVerification);
function dispatch(arg0: any) {
  throw new Error("Function not implemented.");
}
